import { render, staticRenderFns } from "./NotActivePage.vue?vue&type=template&id=c94fab88&scoped=true"
import script from "./NotActivePage.vue?vue&type=script&lang=js"
export * from "./NotActivePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94fab88",
  null
  
)

export default component.exports